import React from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import styled from "styled-components";

const Group = styled.div`
  display: inline-flex;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 999px;
  padding: 2px;
  font-size: 0.8em;
  flex-shrink: 0;
`;

const Option = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  text-decoration: none;
  color: #666;
  font-weight: 500;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    color: #1a1a1a;
  }

  &[aria-current="page"] {
    background: #2e7d32;
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
`;

const ViewToggle = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const current = searchParams.get("view") === "overview" ? "overview" : "map";

  const mapParams = new URLSearchParams(searchParams);
  mapParams.delete("view");
  const mapSearch = mapParams.toString();
  const mapTo = `${location.pathname}${mapSearch ? `?${mapSearch}` : ""}`;

  const overviewParams = new URLSearchParams(searchParams);
  overviewParams.set("view", "overview");
  const overviewTo = `${location.pathname}?${overviewParams.toString()}`;

  return (
    <Group role="tablist" aria-label="View">
      <Option
        to={overviewTo}
        replace
        aria-current={current === "overview" ? "page" : undefined}
      >
        <i className="fas fa-list" /> Overview
      </Option>
      <Option
        to={mapTo}
        replace
        aria-current={current === "map" ? "page" : undefined}
      >
        <i className="fas fa-map-marker-alt" /> Map
      </Option>
    </Group>
  );
};

export default ViewToggle;
